import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import BaseButton from '@/components/BaseButton'
import goTopButton from '@/components/GoTopButton'

import { PinSendingMode } from '@/enums/pin-sending-mode.enum.js'
import { showProductDetails, showAccountDetails, showCardDetails, showOrderDetails, showBeneficiaryDetails } from '@/tools/utils.js'

export default {

  components: {
    BaseButton,
    goTopButton
  },

  setup () {
    return { v$: useVuelidate() }
  },

  data () {
    return {
      permissions: JSON.parse(sessionStorage.getItem('user')).permissions,
      criterias: {
        pinSendingMode: '',
        orderFileId: '',
        orderReference: '',
        pinDeliveryAddrLine1: '',
        pinDeliveryAddrLine2: '',
        pinDeliveryAddrLine3: '',
        pinDeliveryAddrLine4: '',
        pinDeliveryAddrLine5: '',
        pinDeliveryAddrZipCode: '',
        pinDeliveryAddrTown: '',
        pinDeliveryAddrCountryCode: '',
        pinDeliveryAddrPhoneNumber: '',
        pinDeliveryAddrCellNumber: '',
        pinDeliveryAddrEmail: '',
        pinNotDeliveredAddrLine1: '',
        pinNotDeliveredAddrLine2: '',
        pinNotDeliveredAddrLine3: '',
        pinNotDeliveredAddrLine4: '',
        pinNotDeliveredAddrLine5: '',
        pinNotDeliveredAddrZipCode: '',
        pinNotDeliveredAddrTown: '',
        pinNotDeliveredAddrCountryCode: '',
        pinNotDeliveredAddrPhoneNumber: ''
      },
      order: null,
      orderDetail: null,
      responseErr: null,
      isProcessing: false,
      validationError: false,
      modalResponseErr: null,
      isModalProcessing: false,
      modalError: false,
      pan: {
        unmaskedPan: null,
        panImg: null,
        isPanProcessing: false,
        panResponseErr: null
      },
      pinSendingModeNum: PinSendingMode
    }
  },
  created () {
    this.order = this.$store.state.orders.order
    if (!this.order) {
      this.$store.dispatch('orders/invalidData', 'ORDER_EMPTY')
      this.$router.push({ name: 'order-list' })
    }
    else {
      this.$store.dispatch('orders/resetInvalidData')
      this.getDetail()
    }
  },
  methods: {
    hasPermission (permission) {
      if (!String.prototype.includes) {
        return this.permissions.indexOf(permission, 0) !== -1
      } else {
        return this.permissions.includes(permission)
      }
    },
    async getDetail () {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('orders/resetDetail')
      await this.$store.dispatch('orders/getDetail', {
        orderId: this.order.orderId,
        orderType: this.order.orderType,
        beneficiaryServiceRef: this.order.beneficiaryServiceRef,
        distributorRef: this.order.distributorRef,
        issuerId: this.getIssuerId(this.order.distributorRef)
      }).then(
        response => {
          this.isProcessing = false
          this.responseErr = response.errorCode
        },
        error => {
          this.isProcessing = false
          this.responseErr = error.data.errorCode
        }
      )
    },
    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },
    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },
    translateStatus (statusCode) {
      return statusCode.replace('ORDER_', '')
    },
    remindPin () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.runRemindPin()
      }
    },
    async runRemindPin () {
      this.isModalProcessing = true
      this.modalResponseErr = null

      await this.$store.dispatch('orders/remindPin', {
        distributorRef: this.order.distributorRef,
        issuerId: this.getIssuerId(this.order.distributorRef),
        orderId: this.order.orderId,
        orderType: this.order.orderType,
        pinSendingMode: this.criterias.pinSendingMode,
        orderFileId: this.criterias.orderFileId,
        orderReference: this.criterias.orderReference,
        pinDeliveryAddrLine1: this.criterias.pinDeliveryAddrLine1,
        pinDeliveryAddrLine2: this.criterias.pinDeliveryAddrLine2,
        pinDeliveryAddrLine3: this.criterias.pinDeliveryAddrLine3,
        pinDeliveryAddrLine4: this.criterias.pinDeliveryAddrLine4,
        pinDeliveryAddrLine5: this.criterias.pinDeliveryAddrLine5,
        pinDeliveryAddrZipCode: this.criterias.pinDeliveryAddrZipCode,
        pinDeliveryAddrTown: this.criterias.pinDeliveryAddrTown,
        pinDeliveryAddrCountryCode: this.criterias.pinDeliveryAddrCountryCode,
        pinDeliveryAddrPhoneNumber: this.criterias.pinDeliveryAddrPhoneNumber,
        pinDeliveryAddrCellNumber: this.criterias.pinDeliveryAddrCellNumber,
        pinDeliveryAddrEmail: this.criterias.pinDeliveryAddrEmail,
        pinNotDeliveredAddrLine1: this.criterias.pinNotDeliveredAddrLine1,
        pinNotDeliveredAddrLine2: this.criterias.pinNotDeliveredAddrLine2,
        pinNotDeliveredAddrLine3: this.criterias.pinNotDeliveredAddrLine3,
        pinNotDeliveredAddrLine4: this.criterias.pinNotDeliveredAddrLine4,
        pinNotDeliveredAddrLine5: this.criterias.pinNotDeliveredAddrLine5,
        pinNotDeliveredAddrZipCode: this.criterias.pinNotDeliveredAddrZipCode,
        pinNotDeliveredAddrTown: this.criterias.pinNotDeliveredAddrTown,
        pinNotDeliveredAddrCountryCode: this.criterias.pinNotDeliveredAddrCountryCode,
        pinNotDeliveredAddrPhoneNumber: this.criterias.pinNotDeliveredAddrPhoneNumber
      }).then(
        () => {
          this.isModalProcessing = false
          this.modalError = false
          document.getElementById('closeModal').click()
        },
        error => {
          this.isModalProcessing = false
          this.modalError = true
          this.modalResponseErr = error.data.errorCode
        }
      )
    },

    showProduct (productExternalReference) {
      this.$store.dispatch('products/setProduct',{
        prb1: productExternalReference,
        prb7: this.order.distributorRef
      })
      return showProductDetails()
    },

    showBeneficiary (beneficiary) {
      this.$store.dispatch('beneficiaries/setBeneficiaryService', {
        beneficiaryServiceRef: beneficiary[0],
        distributorRef: beneficiary[1],
        funderContractRef: beneficiary[2],
        issuerId: this.getIssuerId(this.order.distributorRef),
        singleFunderAccount: this.$store.state.orders.orderDetail.singleFunderAccount
      })
      return showBeneficiaryDetails()
    },

    showAccount (accountDetailsPageContext) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountDetailsPageContext[0],
        distributorRef: this.order.distributorRef,
        beneficiaryServiceRef: accountDetailsPageContext[2],
        issuerId: accountDetailsPageContext[1],
        singleFunderAccount: this.$store.state.orders.orderDetail.singleFunderAccount
      })
      return showAccountDetails()
    },

    showCard (card) {
      this.$store.dispatch('cards/setCard', { card: card })
      return showCardDetails()
    },

    showOrder (order) {
      this.$store.dispatch('orders/setOrder', order)
      return showOrderDetails()
    }
  },

  validations() {
    return {
      criterias: {
        pinSendingMode: { required },
        orderFileId: { },
        orderReference: { },
        pinDeliveryAddrLine1: { required },
        pinDeliveryAddrLine2: { },
        pinDeliveryAddrLine3: { },
        pinDeliveryAddrLine4: { },
        pinDeliveryAddrLine5: { },
        pinDeliveryAddrZipCode: { required },
        pinDeliveryAddrTown: { required },
        pinDeliveryAddrCountryCode: { required },
        pinDeliveryAddrPhoneNumber: { },
        pinDeliveryAddrCellNumber: { required },
        pinDeliveryAddrEmail: { required },
        pinNotDeliveredAddrLine1: { required },
        pinNotDeliveredAddrLine2: { },
        pinNotDeliveredAddrLine3: { required },
        pinNotDeliveredAddrLine4: { },
        pinNotDeliveredAddrLine5: { },
        pinNotDeliveredAddrZipCode: { required },
        pinNotDeliveredAddrTown: { required },
        pinNotDeliveredAddrCountryCode: { required },
        pinNotDeliveredAddrPhoneNumber: { }
      }
    }
  }
}
